module.exports = __webpack_public_path__ + "img/bg05.6f6ac310.gif";